import { useEffect } from "react";
import type { Dispatch, SetStateAction } from "react";

import eventEmitter, { EVENTS } from "src/services/eventEmitter";

import { resetTreeActiveNode, type TagNavNode } from "./index.logic";

const useUpdateCurrentTag = (
  setTreeData: Dispatch<SetStateAction<TagNavNode[]>>
) => {
  useEffect(() => {
    const handler = (tag: { id: string; type: string } | null) => {
      // Defer via microtask so the state update fires after any in-flight
      // React reconciliation cycle that may have triggered this event.
      Promise.resolve().then(() => {
        setTreeData((tree) => resetTreeActiveNode(tree, tag));
      });
    };

    eventEmitter.on(EVENTS.CURRENT_TAG_UPDATED, handler);

    return () => {
      eventEmitter.removeListener(EVENTS.CURRENT_TAG_UPDATED, handler);
    };
  }, [setTreeData]);
};

export default useUpdateCurrentTag;
